function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M62.4,72.5c-0.4,0-0.8-0.2-1.1-0.5c-0.6-0.6-0.7-1.7,0-2.3l32.3-33.4L61.2,3c-0.6-0.6-0.6-1.7,0-2.3 c0.6-0.6,1.7-0.6,2.3,0L98,36.4L63.6,72C63.2,72.3,62.8,72.5,62.4,72.5z"
})), React.createElement("g", null, React.createElement("path", {
  d: "M95,38H2.3c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6H95c0.9,0,1.6,0.7,1.6,1.6C96.6,37.3,95.9,38,95,38z"
})));

var SvgArrowRight = function SvgArrowRight(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97.3 72.3",
    style: {
      enableBackground: "new 0 0 97.3 72.3"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/arrow-right.1f886ed5.svg";
export { SvgArrowRight as ReactComponent };